<template>
    <div>
        <Drawer title="快递信息" v-model="current_express_info_show" width="600">

            <div class="kd_div">
                <Spin v-if="table_loading" fix />

                <div class="kuaidi_title">
                    快递公司：{{ current_express_info.typename }}
                    <img v-if="current_express_info.logo_base64" class="express_logo"
                        :src="current_express_info.logo_base64" alt="">
                </div>
                <div class="kuaidi_title">
                    快递单号：{{ current_express_info.number }}
                </div>

                <div class="kuaidi_shijianzhou">
                    <Timeline>
                        <TimelineItem v-for="(item, i) in current_express_info.list" :key="i">
                            <p class="kuaidi_title">{{ item.time }}</p>
                            <p class="kuaidi_title">{{ item.status }}</p>
                        </TimelineItem>

                    </Timeline>

                </div>
            </div>


        </Drawer>

    </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
    name: "query_express_info",
    data() {
        return {
            current_express_info_show: false,
            current_express_info: {},
            express_number: '',
            phone: '',
            table_loading: false
        }
    },

    methods: {

        open(express_number, phone) {
            this.express_number = express_number
            this.phone = phone
            this.get_express_data()

        },
        get_express_data() {
            var that = this
            var obj = {
                express_number: this.express_number,
                express_phone: this.phone
            }
            this.current_express_info_show = true
            this.table_loading = true
            http("post", process.env.VUE_APP_HOST + "/finance/invoice/get_express_number_info", obj, true).then(
                (res) => {
                    if (res.code == 0) {

                        that.current_express_info = res.data

                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.table_loading = false
                }
            ).catch((res) => {
                that.table_loading = false

                console.log(res, '请求出错')
            })
        },
    }



}
</script>

<style  scoped>
.kd_div{
    position: relative;
}

.kuaidi_shijianzhou {
    padding: 20px 10px
}

.kuaidi_title {
    font-size: 13px;
    padding: 0 10px;
    color: #666;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    ;
}

.express_logo {
    width: 30px;
    height: 30px;
    border-radius: 3px;
    margin-left: 10px;
}
</style>